import {Icon, IconType, NotifyFn} from "peggirkit";
import {CheckIcon, ExclamationCircleIcon} from "@heroicons/react/24/outline";
import React from "react";

export const notifySuccess = (
    msg: string,
    notifyFn: NotifyFn,
    icon: IconType = CheckIcon) => {
    notifyFn({
        icon: (
            <Icon
                className={"text-green-600 dark:text-green-500"}
                icon={icon}
            />
        ),
        message: msg,
    });
};

export const notifyDanger = (
    msg: string,
    notifyFn: NotifyFn,
    icon: IconType = ExclamationCircleIcon) => {
    notifyFn({
        icon: (
            <Icon
                className={"text-red-600 dark:text-red-500"}
                icon={icon}
            />
        ),
        message: msg,
    });
};